import { render, staticRenderFns } from "./ServiceGroup.vue?vue&type=template&id=2eae7e7e&scoped=true&"
import script from "./ServiceGroup.vue?vue&type=script&lang=js&"
export * from "./ServiceGroup.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGroup.vue?vue&type=style&index=0&id=2eae7e7e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eae7e7e",
  null
  
)

export default component.exports